<template>
  <div class="f-warp" id="footer">
    <header>联系我们</header>
    <footer class="layoutMaxWidth flex-between-center">
      <ul class="flex-between-col">
        <li class="display-flex align-items_center">
          <span class="iconfont icon-company"></span>
          <span>上海皓范信息科技有限公司</span>
        </li>
        <li class="display-flex align-items_center">
          <span class="iconfont icon-address"></span>
          <span>上海市浦东新区金苏路200号金桥万创中心H 幢306室</span>
        </li>
        <li class="display-flex align-items_center">
          <span class="iconfont icon-web1"></span>
          <span>www.hot-fan.com</span>
        </li>
        <li class="display-flex align-items_center">
          <span class="iconfont icon-call"></span>
          <span
            >技术咨询：400-660-1715<span class="line"></span
            >商务联系：16628562329（蔡先生）</span
          >
        </li>
      </ul>
      <div class="flex-between-col">
        <img src="@/assets/img/qrCode.png" alt />
        <span>扫码进入公众号</span>
      </div>
    </footer>
    <div class="link-warpper">
      <div class="layoutMaxWidth flex-between-center link">
        <a href="http://kb9eyzxb7gpqxn68.mikecrm.com/M6wFJRJ" target="view_window"
        >合作提交：http://kb9eyzxb7gpqxn68.mikecrm.com/M6wFJRJ</a
      >
      <a href="https://beian.miit.gov.cn" target="view_window"
        >备案序号：沪ICP备16052746号-1</a
      >
      </div>
      
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variable.scss";
.f-warp {
  width: 100%;
  box-sizing: border-box;
  background-color: $primary-color;
  header {
    font-size: 21px;
    font-weight: 530;
    color: white;
    text-align: center;
    padding-top: 38px;
  }
  header::after,
  header::before {
    display: inline-block;
    content: "";
    width: 64px;
    height: 1px;
    background-color: white;
    vertical-align: middle;
    margin-right: 16px;
  }
  header::after {
    margin-right: 0px;
    margin-left: 16px;
  }
  footer {
    padding-top: 35px;
    text-align: center;
    color: white;
    img {
      margin-bottom: 34px;
      width: 103px;
    }
    ul {
      font-size: 13px;
      height: 149px;
      li {
        span:first-child {
          font-size: 20px;
          font-weight: 500;
          margin-right: 10px;
          vertical-align: middle;
        }
        .line {
          display: inline-block;
          width: 1px;
          height: 11px;
          background-color: white;
          margin-left: 10px;
        }
      }
    }
  }
  .link-warpper{
    margin-top: 38px;
    padding: 25px 0;

    background-color: #049c5b;
  }
  .link {
    
    a{
      text-align: center;
      color: rgba($color: #fff, $alpha: 0.6);
      text-decoration: none;
    }
    a:first-child{
      color: white;
    }
  }
}
</style>
